module.exports = {
        srcSet: __webpack_public_path__ + "static/media/euroIconMobile-500.904e6b99.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/euroIconMobile-500.904e6b99.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/euroIconMobile-500.904e6b99.webp",
        toString: function(){return __webpack_public_path__ + "static/media/euroIconMobile-500.904e6b99.webp"},
        
        width: 500,
        height: 500
      }